import {gql} from '@apollo/client';

import {AntibodyFormat} from 'antibodies/AntibodyTypedefs';
import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {AntibodyFormatsQuery} from './__generated/AntibodyFormatsQuery';

export const ANTIBODY_FORMATS_QUERY = gql`
  query AntibodyFormatsQuery @skipAudit @engComponent(name: ANTIBODIES) {
    allAntibodyFormats {
      ...AntibodyFormatGraphQL
    }
  }
  ${getFragmentWrapper('AntibodyFormat').fragment}
`;

export function useAntibodyFormatsQuery(): Array<AntibodyFormat> {
  const result = useBenchlingQuery<AntibodyFormatsQuery>(ANTIBODY_FORMATS_QUERY);
  return result.type === QueryResultType.SUCCESS ? result.data.allAntibodyFormats : [];
}
